<template>
  <div class="row">
    <div id="app1" class="col-md-2">
      <div>TaskLists</div>
      <TaskList ref="taskLists" v-model="taskLists" @update="taskLists_updated" @timestamp_updated="timestamp_updated" @check_update="check_update" />
    </div>
    <div id="app2" class="col-md-10 offset-md-2">
      <router-view ref="tasks" @mounted="tasks_mounted" />
    </div>
  </div>
</template>

<script>
import TaskList from './components/TaskList.vue'

export default {
  name: 'App',
  components: {
    TaskList
  },
  data () {
    return {
      taskLists: []
    }
  },
  created () {
  },
  destroyed () {
  },
  updated (e) {
    // <router-link> で遷移して欲しいのにしてくれないのでとりあえず手でやる
    if (this.$refs.tasks) {
      console.log('App#updated()', e, this.$refs.tasks.tlid(), this.$refs.tasks.current_tasklist_id)
      if (this.$refs.tasks.current_tasklist_id !== this.$refs.tasks.tlid()) {
        this.$refs.tasks.listTasks()
      }
    }
  },
  mounted: function () {
    console.log('JK: App mounted')
    this.$nextTick(() => {
      // 子がマウントされ終わったタイミング
      setInterval(this.periodic.bind(this), 30 * 1000)
    })
  },
  methods: {
    tasks_mounted () {
      console.log('tasks_mounted', this.$refs.tasks, this.$refs.tasks.taskLists.length)
      if (this.$refs.tasks && this.$refs.tasks.taskLists.length === 0) {
        if (this.$refs.taskLists.taskLists.length > 0) {
          console.log('copy already-retrieved taskLists to tasks.taskLists')
          this.$refs.tasks.inject_taskLists(this.$refs.taskLists.taskLists)
        } else {
          console.log('want tasks.taskLists updated')
          this.$refs.taskLists.checkUpdate()
        }
      }
    },
    taskLists_updated (val) {
      this.taskLists = val
      console.log('App taskLists_updated', this.taskLists, this.tasks)
      if (this.$refs.tasks) {
        this.$refs.tasks.inject_taskLists(this.taskLists)
      }
    },
    timestamp_updated (val) {
      console.log('timestamp_updated', val)
      this.$refs.tasks.listTasks()
    },
    periodic () {
      if (this.$refs.taskLists) {
        this.$refs.taskLists.checkUpdate()
      } else {
        console.log('Hmm, no $refs.taskLists')
      }
    },
    check_update () {
      this.$refs.tasks.check_update()
    },
  },
}
</script>

<style>
#app1, #app2 {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* ヘッダー着ける場合使う */
  /*  margin-top: 60px; */
  margin-top: 5px;
}
#app1 {
  z-index: 1;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
}
#app2 {
  padding-left: -15px;
  padding-right: 20px;
}
</style>
